import type { ReactNode } from 'react';
import './floating-panel-title.scss';

interface FloatingPanelTitleProps {
    children: ReactNode;
}

export function FloatingPanelTitle({ children }: FloatingPanelTitleProps): JSX.Element {
    return <h2 className="floating-panel-title">{children}</h2>;
}
